import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { BillingDetailsContainer } from "./BillingDetailsContainer";

export const UsageDetails = () => (
  <BillingDetailsContainer>
    <Typography.LabelLg>
      {t("settings.billing.manage_billing.usage_details.title")}
    </Typography.LabelLg>
  </BillingDetailsContainer>
);
